<template>
  <div>
    <!-- CARD SECTION -->
    <section class="my-3 mt-5 first-section justify-content-around row">
      <div class="new_card col-md-3 col-sm-12">
        <div class="small__card_content_wrapper justify-content-around">
          <div class="car_content_flex_wrapper">
            <img src="@/assets/img/newNepa.svg" width="40px" />
          </div>
          <div>
            <h4 class="dashboard__card__header">
              {{ $t("text.iDashboard.totalHoursOnPowerGrid") }}
            </h4>

            <div class="mt-1" v-if="!showLoader">
              <h3 class="dashboard__card__header_bottom">
                {{ totalPgHours }}
              </h3>
              <span>{{ $t("text.iDashboard.hours") }}</span>
            </div>
            <pulse-loader
              size="15px"
              v-if="showLoader"
              class="mt-3"
            ></pulse-loader>
          </div>
        </div>
      </div>

      <div class="new_card col-md-3 col-sm-12">
        <div class="small__card_content_wrapper justify-content-around">
          <div class="car_content_flex_wrapper">
            <img src="@/assets/img/lightening.svg" width="25px" />
          </div>
          <div>
            <h4 class="dashboard__card__header">
              {{ $t("text.iDashboard.totalHours") }}
            </h4>

            <div class="mt-1" v-if="!showLoader">
              <h3 class="dashboard__card__header_bottom">
                {{ totalGenHours }}
              </h3>
              <span>{{ $t("text.iDashboard.hours") }}</span>
            </div>
            <pulse-loader
              size="15px"
              v-if="showLoader"
              class="mt-3"
            ></pulse-loader>
          </div>
        </div>
      </div>

      <div class="new_card col-md-3 col-sm-12">
        <div class="small__card_content_wrapper justify-content-around">
          <div class="car_content_flex_wrapper">
            <img src="@/assets/img/Vector.svg" width="40px" />
          </div>
          <div>
            <h4 class="dashboard__card__header">
              {{ $t("text.iDashboard.fuelVolume") }}
            </h4>

            <div class="mt-3" v-if="!showLoader">
              <h3 class="dashboard__card__header_bottom">
                {{ totalFuelVol }}
                <!-- {{ totalPgHours }} -->
              </h3>
              <span>{{ $t("text.iDashboard.litres") }}</span>
            </div>
            <pulse-loader
              size="15px"
              v-if="showLoader"
              class="mt-5"
            ></pulse-loader>
          </div>
        </div>
      </div>
    </section>

    <!-- LOADER -->
    <div
      class="showLoaderDiv charts__loader w-full mY-5 mx-auto"
      style="width: 90%"
      v-if="showLoader"
    >
      <div :class="showLoader ? 'loading' : null"></div>
    </div>
    <!-- END LOADER -->

    <div
      class="row mx-auto align-items-center mb-3 dashboard_second_row_right"
      v-if="!showLoader"
    >
      <div class="dashboard_chart col-md-4">
        <div v-show="consumptionstatus === 'daily'">
          <highcharts
            :options="donutChart"
            class=""
            style="padding-top: 60px"
          ></highcharts>
        </div>
      </div>

      <div class="dashboard_chart col-md-8">
        <div v-show="consumptionstatus === 'daily'">
          <highcharts
            :options="dailyUsageChart"
            class=""
            style="padding-top: 60px"
          ></highcharts>
        </div>
      </div>
    </div>

    <section class="bg-white rounded table-section">
      <ejs-grid
        v-show="!showLoader"
        ref="dataGrid"
        :created="refreshGrid"
        :allowPaging="true"
        :allowSorting="true"
        :pageSettings="pageSettings"
        :toolbar="toolbar"
        :searchSettings="search"
        :allowExcelExport="true"
        :allowPdfExport="true"
        :toolbarClick="toolbarClick"
        :locale="usedLang"
      >
        <e-columns>
          <e-column width="40" field="index" headerText="#"></e-column>
          <e-column
            field="branchName"
            width="180"
            :headerText="$t('text.iDashboard.site')"
          ></e-column>
          <e-column
            field="powerGridHours"
            width="180"
            :headerText="$t('text.iDashboard.power')"
          ></e-column>

          <e-column
            field="generatorHours"
            width="180"
            :headerText="$t('text.iDashboard.generator')"
          ></e-column>

          <e-column
            field="tankConsumption"
            width="180"
            :headerText="$t('text.iDashboard.volumeConsumed')"
          ></e-column>
        </e-columns>
      </ejs-grid>
      <TableLoader :showLoader="showLoader" />
    </section>
  </div>
</template>

<script>
import AdminMasterLayout from "@/views/Industrial/AdminMasterLayout.vue";
import TableLoader from "@/components/tableLoader/index";
import configObject from "@/config";
import { Chart } from "highcharts-vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";

export default {
  props: ["maxDate", "dateRange", "startDatee", "endDatee"],
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  components: {
    AdminMasterLayout,
    TableLoader,
    Highcharts: Chart,
    PulseLoader,
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      showLoader: true,
      totalPgHours: 0,
      totalGenHours: 0,
      donutData: [],
      startDate: this.startDatee,
      endDate: this.endDatee,
      totalFuelVol: 0,
      companyID: localStorage.getItem("companyID")
        ? localStorage.getItem("companyID")
        : this.$route.query.companyID,
      pageSettings: { pageSizes: [12, 50, 100, 200], pageCount: 4 },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      consumptionstatus: "daily",
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      donutChart: {
        chart: {
          type: "pie",

          options3d: {
            enabled: true,
            alpha: 45,
          },
        },
        title: {
          text: this.$t("text.omit.consumptionChart"),
        },

        plotOptions: {
          pie: {
            innerSize: 200,
            depth: 45,
            size: "90%",
            colors: ["#FCD462", "#370F70"],
          },
        },
        series: [
          {
            name: "Delivered amount",
            data: this.donutData,
          },
        ],
      },
      dailyUsageChart: {
        title: {
          text: this.$t("text.iMarkMaintenance.conGraph"),
        },
        chart: {
          height: "50%",
          type: "column",
        },

        xAxis: {
          categories: [],
          crosshair: false,
        },
        yAxis: {
          min: 0,
          title: {
            text: this.$t("text.iDashboard.dailyUsageHours"),
          },
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        series: [],
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                chart: {
                  height: 300,
                },
                subtitle: {
                  text: null,
                },
                navigator: {
                  enabled: false,
                },
              },
            },
          ],
        },
      },
    };
  },

  created() {
    this.getBranchConsumption();
    this.PowerUseChart();
    this.getCompanyPowerUseDailyUsage();
    this.getCompanyTotalFuelUse();
  },
  watch: {
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
      }
      this.getCompanyPowerUseDailyUsage(this.companyID);
      this.PowerUseChart();
      this.getBranchConsumption();
      this.getCompanyTotalFuelUse();
    },
  },
  methods: {
    changeConsumptionStatus(e) {
      if (e.target.value === "hourly") {
        this.consumptionstatus = "hourly";
      } else if (e.target.value === "daily") {
        this.consumptionstatus = "daily";
      } else {
        this.consumptionstatus = "monthly";
      }
    },

    getBranchConsumption() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/PowerUse/Company/${
            this.$route.query.companyID
              ? this.$route.query.companyID
              : this.companyID
          }?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )

        .then((res) => {
          this.showLoader = false;
          let index = 0;
          let genArr = [];
          let pgArr = [];
          res.data.forEach((el) => {
            index++;
            el.index = index;
            if (el.powerGridHours) {
              pgArr.push(el.powerGridHours);
            }
            if (el.generatorHours) {
              genArr.push(el.generatorHours);
            }

            let totalPgHours = pgArr.reduce((acc, cur) => {
              return acc + cur;
            }, 0);
            let totalGenHours = genArr.reduce((acc, cur) => {
              return acc + cur;
            }, 0);

            this.totalPgHours = totalPgHours.toFixed(2);
            this.totalGenHours = totalGenHours.toFixed(2);

            el.generatorHours = el.generatorHours.toFixed(2);
            el.powerGridHours = el.powerGridHours.toFixed(2);
            el.tankConsumption = el.tankConsumption.toFixed(2);
          });
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: res.data,
          });
        });
    },

    PowerUseChart() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/PowerUseChart/Company/${
            this.$route.query.companyID
              ? this.$route.query.companyID
              : companyID
          }?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((res) => {
          let gen = res.data.generatorHours.toFixed(2);
          let power = res.data.powerGridHours.toFixed(2);

          let genPie = [this.$t("text.iReport.generator"), Number(gen)];
          let powerPie = [this.$t("text.iReport.powerGrid"), Number(power)];
          this.donutData = [genPie, powerPie];
          // console.log(this.donutData);
          this.donutChart.series[0].data = this.donutData;
        });
    },

    getCompanyPowerUseDailyUsage() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/IndustrialDashboard/PowerUseDaily/${
            this.$route.query.companyID
              ? this.$route.query.companyID
              : companyID
          }?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((res) => {
          res.data.forEach((x) => {
            let date = new Date(x.date);
            const newDate = this.$moment(date).format("MMMM D");
            x.date = newDate;
          });
          let gen = res.data.filter((el) => el.source === "Generator");
          let powerGrid = res.data.filter((el) => el.source === "Power Grid");
          let powerArr = powerGrid.map((el) => {
            return Number(el.hours.toFixed(2));
          });
          let genArr = gen.map((el) => {
            return Number(el.hours.toFixed(2));
          });

          let cats = [];
          gen.forEach((el) => {
            cats.push(el.date);
          });
          let genSeries = [
            {
              name: this.$t("text.iReport.generator"),
              data: genArr,
              color: "#FCD462",
            },
          ];

          let powerSeries = [
            {
              name: this.$t("text.iReport.powerGrid"),
              data: powerArr,
              color: "#370F70",
            },
          ];

          this.dailyUsageChart.series = [...genSeries, ...powerSeries];
          this.dailyUsageChart.xAxis.categories = cats;
        })
        .catch((error) => {});
    },
    //COMPANY TOTAL FUEL USE
    getCompanyTotalFuelUse() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/IndustrialDashboard/DayFuelUse/${
            this.$route.query.companyID
              ? this.$route.query.companyID
              : companyID
          }?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.totalFuelVol = res.data.vol.toLocaleString("en", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
          });
        })
        .catch((error) => {});
    },
    convertTime(time) {
      let newTime = time.split(":");
      let seconds = Number(newTime[2]).toFixed(2);
      return `${newTime[0]}: ${newTime[1]}: ${seconds}`;
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },

    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
  },
};
</script>

<style scoped>
.new_card {
  width: 100%;
  border-radius: 20px;
  background-color: white;
  border-bottom: 5px solid #370f70;
  height: 180px;
}
.first-section {
  width: 95%;
  margin: auto auto;
}
.dashboard__card {
  align-items: normal;
  width: 100% !important;
}
.small__card_content_wrapper {
  display: flex !important;
  justify-content: space-between;
  flex-direction: row;
  margin: auto auto;
  padding-top: 30px;
  width: 105%;
}
.dashboard__card__header {
  font-size: 1rem;
  font-weight: 500;
}
.car_content_flex_wrapper {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 77px;
  height: 68px;
  margin-top: 30px;
  margin-right: 10px;
  border-radius: 20px;
  opacity: 1;
  background: #370f70;
}

.small__card_content_wrapper span {
  font-family: Poppins;
  font-size: 16px;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: -0.01em;
  text-align: left;
}
.table-section {
  width: 95%;
  margin: auto auto;
  height: 400px;
}
@media only screen and (max-width: 600px) {
  .new_card {
    display: block;
    width: 100%;
  }
  .first-section {
    flex-direction: column;
  }
}
</style>
